import { useCallback, useState } from "react";

export const validators = {
  email: (email: string): boolean => {
    const regex =
      /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    return regex.test(email);
  },

  telefono: (telefono: string): boolean => {
    return telefono.length >= 8 && telefono.length <= 15;
  },

  documento: (documento: number | string): boolean => {
    const doc = String(documento);
    return doc.length >= 7 && doc.length <= 9;
  },

  campoRequerido: (valor: any): boolean => {
    return valor !== null && valor !== undefined && valor !== "" && valor !== 0;
  },
};

export const useFormValidation = <T extends Record<string, any>>(initialErrors: T) => {
  const [errors, setErrors] = useState<T>(initialErrors);

  const validateField = useCallback((field: keyof T, value: any, validator: (val: any) => boolean) => {
    const isValid = validator(value);
    setErrors((prev) => ({ ...prev, [field]: !isValid }));
    return isValid;
  }, []);

  const validateAll = useCallback(
    (validations: Array<{ field: keyof T; value: any; validator: (val: any) => boolean }>) => {
      let allValid = true;
      const newErrors = { ...errors } as T;

      validations.forEach(({ field, value, validator }) => {
        const isValid = validator(value);
        (newErrors as any)[field] = !isValid;
        if (!isValid) allValid = false;
      });

      setErrors(newErrors);
      return allValid;
    },
    [errors]
  );

  const clearErrors = useCallback(() => {
    setErrors(initialErrors);
  }, [initialErrors]);

  return { errors, validateField, validateAll, clearErrors };
};
